import React from 'react';
import { currencyFormat } from '@components/common/utils';
/** Get number only */
export const filterNumber = (str) => {
    if (!str) return true
  }
const Price = (item) => {
    let className = item?.className || 'fw-bolder card__price fz14';
    let prefix = (item?.priceQualifier === "Default" ? "" : item?.priceQualifier) || (item?.price_qualifier === "Default" ? "" : item?.price_qualifier);
    let suffix = '';
    let price = (item?.priceDetails || item?.price || '').toLocaleString()
    if (item.status === 'Let' || item.status === 'To Let') {
        prefix = '';
        suffix = (item?.priceQualifier === "Default" ? "" : item?.priceQualifier) || (item?.price_qualifier === "Default" ? "" : item?.price_qualifier);
    }

    return (
        <>
        {item?.type === "newhomes" ? 
        <>
        {currencyFormat(price, '£', false)}{currencyFormat(item?.max_price, '£', false, true)}
        </>
        :
        <>
         {prefix && <span className="card__subtitle fz14 d-inline-block">{prefix}&nbsp;</span>}
            <span className={className}>
            {currencyFormat(price, '£', false)}
            </span>
            {suffix && <span className="card__subtitle fz14 d-inline-block">&nbsp;{suffix}</span>}
            </>
}
        </>
    )
}

export default Price;
